import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const DraggableIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 22 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Drag' transform='translate(-1)'>
        <path
          id='Caminho_8'
          data-name='Caminho 8'
          d='M1.816,9.976l3.139,2.76a.516.516,0,0,1-.683.774L.278,9.976A.885.885,0,0,1,0,9.46a.885.885,0,0,1,.278-.516l3.992-3.5a.516.516,0,1,1,.706.754L1.816,8.943l6.668.006a.516.516,0,1,1,0,1.033Z'
          transform='translate(21.465) rotate(90)'
        />
        <path
          id='Caminho_10'
          data-name='Caminho 10'
          d='M16.373,38.033H37.34a.516.516,0,1,0,0-1.033H16.373a.516.516,0,1,0,0,1.033Z'
          transform='translate(-14.856 -27.033)'
          fillRule='evenodd'
        />
        <path
          id='Caminho_12'
          data-name='Caminho 12'
          d='M1.816,3.664,4.954.9A.516.516,0,0,0,4.271.129L.278,3.664A.885.885,0,0,0,0,4.181.885.885,0,0,0,.278,4.7L4.27,8.2a.516.516,0,1,0,.706-.754L1.816,4.7l6.668-.006a.516.516,0,1,0,0-1.033Z'
          transform='translate(7.831 24) rotate(-90)'
        />
        <path
          id='Caminho_13'
          data-name='Caminho 13'
          d='M16.373,38.033H37.34a.516.516,0,1,0,0-1.033H16.373a.516.516,0,1,0,0,1.033Z'
          transform='translate(-14.856 -24)'
          fillRule='evenodd'
        />
      </g>
    </svg>
  );
};
